import type { GridProps } from '@chakra-ui/react'
import { Grid } from '@chakra-ui/react'
import React from 'react'

import { useQuotes } from '../context/QuotesContext'

interface QuotesFilterWrapperProps extends GridProps {
  children: React.ReactNode
  forceShowFilter?: boolean
}

export const QuotesFilterWrapper = ({
  children,
  sx,
  forceShowFilter = false,
  ...rest
}: QuotesFilterWrapperProps) => {
  const { showFilter } = useQuotes()

  if (!showFilter && !forceShowFilter) return null

  return (
    <Grid
      sx={{
        display: 'grid',
        position: 'relative',
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Grid>
  )
}
